<script setup lang="ts">
import { t } from '@/utils/i18n';
const consoleIcon = `${import.meta.env.BASE_URL}trx-console.svg`;
</script>

<template>
  <img :src="consoleIcon" :alt="t('TRX live console')" class="mx-auto" />
</template>
